import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-28 overflow-hidden" data-id="element-182">
      {/* Angled top divider */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-brand-darker" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0 100%)'
    }} data-id="element-183" />

      <div className="relative z-10 max-w-3xl mx-auto px-4" data-id="element-184">
        <SectionReveal data-id="element-185">
          <p className="text-4xl mb-4 text-center" data-id="element-186">💣</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-10 uppercase tracking-[-0.02em]" data-id="element-187">
            Todos los meses pasa lo mismo…
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-188">
          <div className="space-y-6 text-center mb-12" data-id="element-189">
            <p className="text-lg sm:text-xl text-gray-300 font-body leading-relaxed" data-id="element-190">
              Pagás la factura… y sentís que algo no cierra.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 font-body leading-relaxed" data-id="element-191">
              Pero lo peor no es eso.
            </p>
            <p className="text-xl sm:text-2xl text-blue-400 font-body font-bold leading-relaxed" data-id="element-192">
              👉 Lo peor es que probablemente estás perdiendo plata sin darte
              cuenta.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.2} data-id="element-193">
          <div className="space-y-4 mb-12" data-id="element-194">
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-195">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-196" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-197">
                Aparatos que consumen sin que lo sepas
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-198">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-199" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-200">
                Errores que inflan tu factura todos los meses
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-201">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-202" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-203">
                Subsidios mal configurados
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-204">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-205" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-206">
                Hábitos que te hacen perder miles de pesos
              </p>
            </div>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.3} data-id="element-207">
          <p className="text-xl sm:text-2xl text-white font-body text-center mb-12 font-bold" data-id="element-208">
            Y nadie te explica cómo solucionarlo.
          </p>
        </SectionReveal>

        <SectionReveal delay={0.4} data-id="element-209">
          <div className="text-center" data-id="element-210">
            <CTAButton text="QUIERO PAGAR MENOS YA" scrollTo="oferta" size="lg" data-id="element-211" />
          </div>
        </SectionReveal>
      </div>
    </section>;
}